import { v4 as uuidv4 } from 'uuid'

import {
  CompletePageConditionalRuleModel,
  CompletePageConditionalRuleResponse,
} from '@/domain/model/forms'
import { User } from '@/types/user'

export const transformToCompleteConditionalRuleForm = (
  input: CompletePageConditionalRuleModel[] | undefined,
  user: User | null
): CompletePageConditionalRuleResponse[] | undefined => {
  if (!input) return
  const now = new Date().toISOString()

  return input.map((item) => {
    let redirect_url = null
    let custom_complete_page = null
    const hasCompletePage = Boolean(item.custom_complete_page)
    const hasUrl = Boolean(item.redirect_url)
    if (hasCompletePage) {
      custom_complete_page = item.custom_complete_page
    }
    if (hasUrl) {
      redirect_url = item.redirect_url
    }
    return {
      id: item.id || uuidv4(),
      form: {
        id: item.form || '',
      },
      packet: item.packet
        ? {
            id: item.packet,
          }
        : undefined,
      created_by: {
        first_name: user?.first_name,
        last_name: user?.last_name,
      },
      created_at: now,
      updated_at: now,
      conditional_rule_groups: item.conditional_rule_groups,
      redirect_url,
      custom_complete_page,
      enabled: item.enabled,
      is_new: item.is_new,
      is_updated: item.is_updated,
      order: item.order,
    }
  })
}
